<template>
  <div>
    <!-- <ResultWindow v-bind:calc="calc"></ResultWindow> -->
    <!-- <h2 class="text-center colorblue">
      Стоимость банковской гарантии. Онлайн калькулятор
    </h2> -->
    <v-row>
      <v-col cols="12" style="
          display: flex;
          justify-content: center;
          margin-bottom: 0;
          padding-bottom: 0;
        ">
        <CalcAds />
      </v-col>
    </v-row>

    <v-row>
      <transition name="fade">
        <v-col :cols="calcCols" class="fadeAnimation">
          <v-form id="calculatorBlock" lazy-validation>
            <!-- <div class="borderedStyle"> -->
            <v-card outlined>
              <v-card-text class="pb-1 pt-1 pl-1 pr-1">
                <!-- <div class="borderedStyle"> -->
                <v-row no-gutters>
                  <v-col cols="12" class="text-center pl-5 pr-5">
                    <!-- <v-autocomplete
                      dense
                      :items="protocolList"
                      label="№ Закупки"
                      clearable
                      :loading="protocolListLoading"
                      v-model="purchase_number"
                      prepend-icon='search'
                      @click:clear="clearProtocol"
                      @click:prepend='findProtocol($event)'
                    /> -->
                    <v-text-field v-model="purchase_number" label="№ Закупки" clearable append-icon="search"
                      @click:clear="clearProtocol" @click:append="FindProtocol" @change="FindProtocol" />
                  </v-col>
                </v-row>
                <!-- <v-row no-gutters>
                <v-col md="12" class="text-center mt-5">
                  <span class="colorblue subh pl-2">Сумма гарантии</span>
                </v-col>
              </v-row> -->
                <v-row no-gutters>
                  <v-col md="12" class="text-center pl-5 pr-5">
                    <priceInput class="calcsumm" v-model="calc.summ" placeholder="Введите сумму гарантии"
                      :messages="[smpText]" />
                    <div class="centerBlock flex" style="margin: 15px 10px 0 10px">
                      <!-- <v-list> -->
                      <!-- <v-list-item>
                          <v-list-item-action> -->
                      <span>
                        Антидемпинг
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">info</v-icon>
                          </template>
                          <span>Требуется увеличение суммы БГ</span>
                        </v-tooltip>
                      </span>
                      <!-- <v-list-item-title class="mr-10"
                            ></v-list-item-title
                          > -->
                      <!-- </v-list-item-action>
                          <v-list-item-action class="mr-5"> -->
                      <v-checkbox id="trebUvel" class="pb-0 pt-0 mt-0 mb-0" v-model="calc.trebUvelSumm"
                        @change="onUvelSumm($event, 1.5)" :disabled="calc.summ <= 0">
                        <template v-slot:label>
                          <div>
                            в 1.5 раза
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">info</v-icon>
                              </template>
                              В соответствии с правилами ст. 37 ч.1 и ч.2 №44-ФЗ
                            </v-tooltip>
                          </div>
                        </template>
                      </v-checkbox>
                      <!-- </v-list-item-action>
                          <v-list-item-action> -->
                      <v-checkbox id="trebUvel" class="pb-0 pt-0 mt-0 mb-0" v-model="calc.trebUvelSumm2"
                        @change="onUvelSumm($event, 2)" :disabled="calc.summ <= 0">
                        <template v-slot:label>
                          <div>
                            в 2 раза
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">info</v-icon>
                              </template>
                              В соответствии с правилами п. 205 № 615-ПП
                            </v-tooltip>
                          </div>
                        </template>
                      </v-checkbox>
                      <!-- </v-list-item-action> -->
                      <!-- </v-list-item> -->
                      <!-- </v-list> -->
                    </div>
                    <div class="centerBlock colorred" v-if="calc.message !== ''">
                      {{ calc.message }}
                    </div>
                  </v-col>
                </v-row>
                <!-- </div> -->
              </v-card-text>
              <v-card-text class="pl-5 pr-5">
                <!-- <div class="borderedStyle"> -->
                <v-row>
                  <!-- <v-col md="3" class="text-center">
                  <span class="colorblue subh pl-2">Срок гарантии</span>
                </v-col> -->
                  <v-col md="5">
                    <v-text-field class="custom-font" v-model="calc.date" label="Гарантия дд.мм.гггг" persistent-hint
                      v-mask="rules.dateMask" prepend-icon="с" @focus="OnTextFielsFocus($event)" @blur="
                        setPickerToNewDateUniversal('date', 'dateConverted')
                        ">
                      <template v-slot:append-outer>
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="true" transition="scale-transition"
                          left max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-icon left v-on="on">event</v-icon>
                          </template>
                          <v-date-picker first-day-of-week="1" v-model="calc.dateConverted" no-title @input="
                            InputDataPickerUniversal(
                              'date',
                              'dateConverted',
                              'menu1'
                            )
                            "></v-date-picker>
                        </v-menu>
                      </template>
                    </v-text-field>
                    <!--  -->
                    <div class="plusfive_wrapper">
                      <a href id="plusfive" class="pl-2 pr-2" @click.prevent="getDatesSubtractFiveDays">- 5 дней</a>
                      <a href id="plusfive" class="pl-2 pr-2" @click.prevent="getDatesAddFiveDays">+ 5 дней</a>
                    </div>
                  </v-col>
                  <v-col md="5">
                    <v-text-field class="custom-font" v-model="calc.date2" label="Гарантия дд.мм.гггг" persistent-hint
                      v-mask="rules.dateMask" prepend-icon="по" @focus="OnTextFielsFocus($event)" @blur="
                        setPickerToNewDateUniversal('date2', 'dateConverted2')
                        ">
                      <template v-slot:append-outer>
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="true" transition="scale-transition"
                          max-width="290px" min-width="290px" left>
                          <template v-slot:activator="{ on }">
                            <v-icon left v-on="on">event</v-icon>
                          </template>
                          <v-date-picker first-day-of-week="1" v-model="calc.dateConverted2" no-title @input="
                            InputDataPickerUniversal(
                              'date2',
                              'dateConverted2',
                              'menu12'
                            )
                            "></v-date-picker>
                        </v-menu>
                      </template>
                    </v-text-field>
                    <div class="plusfive_wrapper" v-if="calc.msgDate">
                      <div class="err" style="color: red">Проверьте дату</div>
                    </div>
                  </v-col>
                  <v-col md="2">
                    <v-text-field v-model="calc.days" id="getDays" label="Гарантия дней" required name="days"
                      type="number" />
                  </v-col>
                </v-row>
                <!-- <v-row>
                <v-col md="3" class="text-center"> </v-col>
                <v-col
                  md="9"
                  :class="calc.srok_message.color"
                  v-if="calc.srok_message.message"
                >
                  {{ calc.srok_message.message }}
                </v-col>
              </v-row> -->
                <!-- </div> -->
              </v-card-text>
              <v-card-text class="pb-1 pt-1 pl-1 pr-1">
                <!-- <div class="borderedStyle"> -->
                <v-row>
                  <v-col md="6" class="pt-0 pb-0">
                    <v-select v-model="calc.purchasesVal" class="pl-5 pr-5 pt-0 pb-3" :items="purchases"
                      :rules="[(v) => !!v || 'Выберете вид закупки']" item-text="name" item-value="id"
                      @change="onChangePurchases($event)" label="Вид закупки" required></v-select>
                    <v-select v-model="calc.quaranteesVal" class="pl-5 pr-5 pt-0 pb-3" :items="quarantees"
                      :rules="[(v) => !!v || 'Введите вид гарантии']" item-text="name" item-value="id"
                      @change="onChangeQuarantees($event)" label="Вид гарантии" required></v-select>
                  </v-col>
                  <v-col md="6" class="pt-0 pb-0">
                    <!-- <v-switch
                    false-value="Нет"
                    true-value="Да"
                    v-model="calc.isBS"
                    class="mb-2"
                  >
                    <template v-if="calc.isBS == 'Да'" v-slot:label>
                      <span class="activeSwitch"
                        >Условие о бесспорном списании</span
                      >
                    </template>
                    <template v-else v-slot:label
                      >Условие о бесспорном списании</template
                    >
                  </v-switch> -->
                    <v-switch false-value="Нет" true-value="Да" class="pl-0 pr-0 pt-2 pb-0 mt-0"
                      v-model="calc.isGarFormZak">
                      <template v-if="calc.isGarFormZak == 'Да'" v-slot:label>
                        <span class="activeSwitch">Гарантия по форме заказчика</span>
                      </template>
                      <template v-else v-slot:label>Гарантия по форме заказчика</template>
                    </v-switch>
                    <v-switch class="pl-0 pr-0 pt-0 pb-0 mt-0" false-value="Нет" true-value="Да" v-model="calc.isPaper">
                      <template v-if="calc.isPaper == 'Да'" v-slot:label>
                        <span class="activeSwitch">Требуется оригинал гарантии на бумаге</span>
                      </template>
                      <template v-else v-slot:label>Требуется оригинал гарантии на бумаге</template>
                    </v-switch>
                    <v-switch class="selects pl-0 pr-0 pt-0 pb-0 mt-0" false-value="Нет" true-value="Да"
                      v-model="calc.isAvans" :readonly="(() =>
                        calc.quaranteesVal == 2 ||
                          calc.quaranteesVal == 4 ||
                          calc.quaranteesVal == 3
                          ? true
                          : false)()
                        ">
                      <template v-if="calc.isAvans == 'Да'" v-slot:label>
                        <span class="activeSwitch">Наличие аванса</span>
                      </template>
                      <template v-else v-slot:label>Наличие аванса</template>
                    </v-switch>
                  </v-col>
                </v-row>
                <!-- </div> -->
              </v-card-text>
              <!-- </v-card> -->
              <!-- </div> -->
              <!-- <div class="borderedStyle mt-3"> -->
              <!-- <v-card> -->
              <v-divider />
              <v-card-text class="pb-1 pt-1 pl-5 pr-5">
                <v-row>
                  <v-col md="12" class="text-center">
                    <h3 class="colorblue">Дополнительные параметры</h3>
                  </v-col>
                  <v-col md="6" class="pt-0 pb-0">
                    <!--v-autocomplete
                    v-model="calc.gar_polz_zaksVal"
                    dense
                    chips
                    :items="gar_polz_zaks"
                    clearable
                    item-text="name"
                    item-value="id"
                    label="Гарантия в пользу заказчика"
                    placeholder="Введите наименование заказчика"
                  ></v-autocomplete-->
                    <v-autocomplete v-model="calc.gar_polz_zaksVal" dense chips :items="gar_polz_zaks" item-text="name"
                      label="Гарантия в пользу заказчика" item-value="id"></v-autocomplete>
                  </v-col>
                  <v-col md="6" class="pt-0 pb-0">
                    <!--v-autocomplete
                    class="filledColor pl-5 pr-5"
                    v-model="calc.your_situationsVal"
                    :items="your_situations"
                    chips
                    dense
                    item-text="name"
                    item-value="id"
                    label="Ситуация у клиента"
                    placeholder="Введите ситуацию у клиента"
                    multiple
                  ></v-autocomplete-->
                    <v-autocomplete class="filledColor" v-model="calc.your_situationsVal" dense chips
                      :items="your_situations" item-text="name" label="Ситуация у клиента" item-value="id"
                      multiple></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="calc.your_situationsVal !== null &&
                  calc.your_situationsVal.length
                  ">
                  <v-col><span style="
                        color: red;
                        font-size: 1.1rem;
                        font-weight: 700;
                        text-align: center;
                        display: block;
                      ">Ознакомьтесь с комментарием к выбранным вами ситуациям у
                      клиента по клику на "Подробнее" в столбце "Особенности
                      выдачи"</span></v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-row>
                  <v-col cols="6" style="display: flex; justify-content: end"><v-btn
                      @click="calcClearForm">Очистить</v-btn></v-col>
                  <v-col cols="6"><v-btn color="green" :loading="getProcessing" :disabled="getProcessing"
                      @click.stop="calcDoCalc">Рассчитать</v-btn></v-col>
                </v-row>
              </v-card-actions>
            </v-card>
            <!-- </div> -->
          </v-form>
        </v-col>
      </transition>
      <transition name="fade_late">
        <v-col :cols="infoCols" class="fadeAnimation">
          <ProtocolInfo :hide="protocolInfoShowed" :protocolInfo="protocolInfo" :winnerInfo="winnerInfo" />
        </v-col>
      </transition>
    </v-row>
  </div>
</template>

<script>
import Globalrules from "@/components/api/rules.js";
import Swal from "sweetalert2";
import moment from "moment";
import priceInput from "@/components/priceInput.vue";
import ProtocolInfo from "./calcagent/protocolInfo.vue";
import { roleObj } from "@/plugins/roles";
import CalcAds from "./calcagent/CalcAds.vue";

export default {
  components: {
    priceInput,
    ProtocolInfo,
    CalcAds,
  },
  computed: {
    agentsFeeMinType: {
      get() {
        return this.$store.getters.get_agentsFeeMinType;
      },
      set(val) {
        this.$store.commit("set_agentsFeeMinType", val);
      },
    },
    protocolInfoShowed: {
      get() {
        return this.$store.getters.getProtocolInfoShowed;
      },
      set(val) {
        this.$store.commit("setProtocolInfoShowed", val);
      },
    },
    protocolInfo() {
      return this.$store.getters.protocol_info;
    },
    infoCols() {
      if (!this.protocolInfoShowed) {
        return 0;
      } else {
        return 4;
      }
    },
    calcCols() {
      if (!this.protocolInfoShowed) {
        return 12;
      } else {
        return 8;
      }
    },
    purchase_number: {
      get() {
        return this.calc.purchase_number;
      },
      set(value) {
        this.$store.dispatch("SET_CALC_PARAM", {
          param: "purchase_number",
          value,
        });
      },
    },
    noteForCalc() {
      var note = "";
      if (this.$store.getters.calc.trebUvelSumm) {
        note = note + " Сумма гарантии увеличена в 1,5 раза";
      } else if (this.$store.getters.calc.trebUvelSumm2) {
        note = note + " Сумма гарантии увеличена в 2 раза";
      } else {
        note =
          note + " Сумма гарантии рассчитана без учёта антидемпинговых мер";
      }
      return note;
    },
    smpText() {
      if (this.$store.getters.calc.smp) {
        if (
          this.$store.getters.calc.purchasesVal === 1 &&
          this.$store.getters.calc.quaranteesVal === 1
        ) {
          return "Закупка для СМП, проверьте сумму гарантии - должна рассчитываться от ПРЕДЛОЖЕННОЙ победителем цены контракта";
        } else return "";
      } else return "";
    },
    purchases() {
      return this.$store.getters.getPurchases;
    },
    quarantees() {
      return this.$store.getters.getQuarantees;
    },
    newCalc() {
      return this.$store.getters.getNewCalculation;
    },
    your_situations() {
      return this.$store.getters.getYour_situations;
    },
    gar_polz_zaks() {
      return this.$store.getters.getGar_polz_zaks;
    },
    calc: {
      get() {
        return this.$store.getters.calc;
      },
      set(val) {
        this.$store.dispatch("SET_CALC", val);
      },
    },
    getProcessing: {
      get() {
        return this.$store.getters.getProcessing;
      },
    },
  },
  async created() {
    if (!this.purchases.length) {
      await this.$store.dispatch("SetLists");
    }
  },
  async mounted() {
    this.setTitle("Стоимость банковской гарантии. Онлайн калькулятор");
    await this.session();
    await this.initDates();
  },

  data() {
    return {
      rules: Globalrules,
      menu1: false,
      menu2: false,
      loading: false,
      originalSumm: null,
      resultDialog: false,
      protocolList: [],
      protocolListLoading: false,
      winnerInfo: null,
    };
  },
  methods: {
    async FindProtocol() {
      if (this.purchase_number !== "") {
        await this.$store.dispatch("CLEAR_PROTOCOL_INFO");
        await this.getProtocoInfo();
        this.protocolInfoShowed = true;
      }
    },
    async clearProtocol() {
      this.purchase_number = null;
      await this.$store.dispatch("CLEAR_PROTOCOL_INFO");
      this.protocolInfoShowed = false;
    },

    async setCalcParam(param, value) {
      await this.$store.dispatch("SET_CALC_PARAM", { param, value });
    },
    async onChangeQuarantees(event) {
      if (event == 2) {
        await this.$store.dispatch("SET_CALC_PARAM", {
          param: "isAvans",
          value: "Нет",
        });
      }
      if (event == 3) {
        await this.$store.dispatch("SET_CALC_PARAM", {
          param: "isAvans",
          value: "Да",
        });
      }
      if (event == 4) {
        await this.$store.dispatch("SET_CALC_PARAM", {
          param: "isAvans",
          value: "Нет",
        });
      }
    },
    RefillQuarantees(qid) {
      this.quarantees.forEach((element) => {
        if (element.id == qid) {
          element.disabled = true;
        }
      });
    },
    ResetQuarantees() {
      this.quarantees.forEach((element) => {
        element.disabled = false;
      });
    },

    async onChangePurchases(event) {
      this.ResetQuarantees();
      switch (event) {
        case 1:
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "isPaper",
            value: "Нет",
          });
          if (this.$store.getters.calc.quaranteesVal == 3) {
            await this.$store.dispatch("SET_CALC_PARAM", {
              param: "quaranteesVal",
              value: null,
            });
          }
          this.RefillQuarantees(3);
          break;
        case 2:
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "isPaper",
            value: "Да",
          });
          break;
        case 3:
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "isPaper",
            value: "Нет",
          });
          if (
            this.$store.getters.calc.quaranteesVal == 3 ||
            this.$store.getters.calc.quaranteesVal == 2
          ) {
            await this.$store.dispatch("SET_CALC_PARAM", {
              param: "quaranteesVal",
              value: null,
            });
          }
          this.RefillQuarantees(2);
          this.RefillQuarantees(3);
          break;
        case 4:
          break;
        case 5:
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "isPaper",
            value: "Да",
          });
          break;
      }
    },

    async getDatesAddFiveDays() {
      if (!this.$store.getters.calc.days) {
        return;
      }
      const [day, month, year] = this.$store.getters.calc.date.split(".");
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: "date",
        value: moment(`${year}-${month}-${day}`)
          .add(5, "days")
          .format("DD.MM.YYYY"),
      });
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: "days",
        value: await this.calcDays(
          this.$store.getters.calc.date,
          this.$store.getters.calc.date2
        ),
      });
      this.setOnlyPicker("date", "dateConverted");

      //return await calcDays(this.date,this.date2);
    },
    async getDatesSubtractFiveDays() {
      if (!this.$store.getters.calc.days) {
        return;
      }
      const [day, month, year] = this.$store.getters.calc.date.split(".");
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: "date",
        value: moment(`${year}-${month}-${day}`)
          .subtract(5, "days")
          .format("DD.MM.YYYY"),
      });
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: "days",
        value: await this.calcDays(
          this.$store.getters.calc.date,
          this.$store.getters.calc.date2
        ),
      });
      this.setOnlyPicker("date", "dateConverted");
    },

    async InputDataPickerUniversal(dateparam, calendarparam, menu) {
      this[menu] = false;
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: dateparam,
        value: this.calendarToDate(this.$store.getters.calc[calendarparam]),
      });
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: "days",
        value: await this.calcDays(
          this.$store.getters.calc.date,
          this.$store.getters.calc.date2
        ),
      });
    },

    correctDate(param) {
      if (!this.$store.getters.calc[param]) return null;
      //const [year, month, day] = param.split(".");
      const [day, month, year] = this.$store.getters.calc[param].split(".");
      const CurrentDate = new Date();
      let fullYear = CurrentDate.getFullYear().toString();
      let yearVar = year;
      let monthVar = month - 1;
      let dayVar = day;
      if (year.length == 2) {
        yearVar = fullYear.substr(0, 2) + year;
      }
      if (yearVar < 2000 || yearVar >= 2050) {
        yearVar = CurrentDate.getFullYear();
      }
      if (monthVar < 0 || monthVar > 11) {
        monthVar = CurrentDate.getMonth().toString().padStart(2, "0");
      }

      if (dayVar < 1 || dayVar > 31) {
        dayVar = CurrentDate.getDate().toString().padStart(2, "0");
      }

      var d = new Date(yearVar, monthVar, dayVar);

      let resulcDate =
        d.getDate().toString().padStart(2, "0") +
        "." +
        (d.getMonth() + 1).toString().padStart(2, "0") +
        "." +
        d.getFullYear().toString();

      return resulcDate;
    },

    async setPickerToNewDateUniversal(dateparam, calendarparam) {
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: dateparam,
        value: this.correctDate(dateparam),
      });
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: calendarparam,
        value: this.dateToCalendar(this.$store.getters.calc[dateparam]),
      });
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: "days",
        value: await this.calcDays(
          this.$store.getters.calc.date,
          this.$store.getters.calc.date2
        ),
      });
    },

    async onUvelSumm(e, count) {
      const add15 = async () => {
        const summ = this.removeCommas(this.$store.getters.calc.summ);
        await this.$store.dispatch("SET_CALC_PARAM", {
          param: "summ",
          value: parseFloat(summ) * 1.5,
        });
      }
      const add20 = async () => {
        const summ = this.removeCommas(this.$store.getters.calc.summ);
        await this.$store.dispatch("SET_CALC_PARAM", {
          param: "summ",
          value: parseFloat(summ) * 2,
        });
      }
      const rem15 = async () => {
        const summ = this.removeCommas(this.$store.getters.calc.summ);
        await this.$store.dispatch("SET_CALC_PARAM", {
          param: "summ",
          value: parseFloat(summ) / 1.5,
        });
      }
      const rem20 = async () => {
        const summ = this.removeCommas(this.$store.getters.calc.summ);
        await this.$store.dispatch("SET_CALC_PARAM", {
          param: "summ",
          value: parseFloat(summ) / 2,
        });
      }

      switch (e) {
        case true:
          {
            switch (count) {
              case 1.5: {
                if (!this.$store.getters.calc.trebUvelSumm && this.$store.getters.calc.trebUvelSumm2) {
                  await add20()
                  await rem15()
                  await this.$store.dispatch("SET_CALC_PARAM", {
                    param: "trebUvelSumm2",
                    value: false,
                  });
                  break
                }
                if (this.$store.getters.calc.trebUvelSumm && !this.$store.getters.calc.trebUvelSumm2) {
                  await add15()
                  await this.$store.dispatch("SET_CALC_PARAM", {
                    param: "trebUvelSumm2",
                    value: false,
                  });
                  break;
                }
                if (this.$store.getters.calc.trebUvelSumm && this.$store.getters.calc.trebUvelSumm2) {
                  await this.$store.dispatch("SET_CALC_PARAM", {
                    param: "trebUvelSumm2",
                    value: false,
                  });
                  rem20()
                  add15()
                  break;
                }
                break
              }

              case 2: {
                if (!this.$store.getters.calc.trebUvelSumm2 && this.$store.getters.calc.trebUvelSumm) {
                  await add15()
                  await rem20()
                  await this.$store.dispatch("SET_CALC_PARAM", {
                    param: "trebUvelSumm",
                    value: false,
                  });
                  break
                }
                if (this.$store.getters.calc.trebUvelSumm2 && !this.$store.getters.calc.trebUvelSumm) {
                  await add20()
                  await this.$store.dispatch("SET_CALC_PARAM", {
                    param: "trebUvelSumm",
                    value: false,
                  });
                  break;
                }
                if (this.$store.getters.calc.trebUvelSumm && this.$store.getters.calc.trebUvelSumm2) {
                  await this.$store.dispatch("SET_CALC_PARAM", {
                    param: "trebUvelSumm",
                    value: false,
                  });
                  rem15()
                  add20()
                  break;
                }
                break
              }
            }
            break
          }
        case false: {
          switch (count) {
            case 1.5: {
              await this.$store.dispatch("SET_CALC_PARAM", {
                param: "trebUvelSumm",
                value: false,
              });
              await rem15()
              break;
            }

            case 2: {
              await this.$store.dispatch("SET_CALC_PARAM", {
                param: "trebUvelSumm2",
                value: false,
              });
              await rem20()
              break;
            }
          }
        }
      }

      // if (e && count === 1.5) {
      //   await this.$store.dispatch("SET_CALC_PARAM", {
      //     param: "trebUvelSumm",
      //     value: false,
      //   });
      //   await rem15()

      // }
      // if (this.$store.getters.calc.trebUvelSumm) {

      //   await this.$store.dispatch("SET_CALC_PARAM", {
      //     param: "trebUvelSumm",
      //     value: true,
      //   });
      // } else {

      //   await this.$store.dispatch("SET_CALC_PARAM", {
      //     param: "trebUvelSumm",
      //     value: false,
      //   });
      // }
    },
    // async onUvelSumm2() {
    //   const summ = this.removeCommas(this.$store.getters.calc.summ);
    //   if (this.$store.getters.calc.trebUvelSumm) {
    //     await this.$store.dispatch("SET_CALC_PARAM", {
    //       param: "trebUvelSumm",
    //       value: false,
    //     });
    //     await this.$store.dispatch("SET_CALC_PARAM", {
    //       param: "summ",
    //       value: parseFloat(summ) / 1.5,
    //     });
    //   }
    //   if (this.$store.getters.calc.trebUvelSumm2) {
    //     await this.$store.dispatch("SET_CALC_PARAM", {
    //       param: "summ",
    //       value: parseFloat(summ) * 2,
    //     });
    //     await this.$store.dispatch("SET_CALC_PARAM", {
    //       param: "trebUvelSumm2",
    //       value: true,
    //     });
    //   } else {
    //     await this.$store.dispatch("SET_CALC_PARAM", {
    //       param: "summ",
    //       value: parseFloat(summ) / 2,
    //     });
    //     await this.$store.dispatch("SET_CALC_PARAM", {
    //       param: "trebUvelSumm2",
    //       value: false,
    //     });
    //   }
    // },
    async calcClearForm() {
      this.clearProtocol();
      await this.$store.dispatch("setNewCalculation");
      await this.$store.dispatch("clearResults");
      await this.$store.dispatch("CLEAR_PROTOCOL_INFO");
      this.$store.commit("setProtocolInfoShowed", false);

      this.initDates();
      this.loading = false;
    },
    clearFilters() {
      this.$store.commit("set_garantZakaz", false);
      this.$store.commit("set_up_box", false);
      this.$store.commit("set_min_tarif", false);
      this.$store.commit("set_what_fee", false);
      this.$store.commit("set_agentsFeeMinType", []);
      this.$store.commit("set_nettoFeeType", []);
      this.$store.commit("set_agentsupMinType", []);
      this.$store.commit("set_agentsupMin", "");
      this.$store.commit("set_agentsupMax", "");
      this.$store.commit("set_down_bank", false);
      this.$store.commit("set_down_agent", false);
      this.$store.commit("set_down_bank_agent", false);
      this.$store.commit("set_edo_sdelka", false);
      this.$store.commit("set_edo_mounth", false);
      this.$store.commit("set_edo_decada", false);
      this.$store.commit("set_edo_week", false);
      this.$store.commit("set_edo_personal", false);
      this.$store.commit("set_principals", []);
      this.$store.commit("set_limits", []);
      this.$store.commit("set_lifes", []);
      this.$store.commit("set_practices", []);
      this.$store.commit("set_packets", []);
      this.$store.commit("set_usns", []);
      this.$store.commit("set_edos", []);
      this.$store.commit("SET_SHOW_FILTRED", false);
      this.$store.commit("SET_FILTRED_PODHODIT_ITEMS", []);
    },
    async calcDoCalc() {
      if (
        !this.$store.getters.calc.summ ||
        this.$store.getters.calc.summ == "" ||
        this.$store.getters.calc.summ == "0.00" ||
        this.$store.getters.calc.summ === "NaN"
      ) {
        Swal.fire({
          icon: "error",
          title: "Ошибка заполнения полей",
          text: "Не заполнено поле 'Сумма БГ'",
        });
        return;
      }

      if (!this.$store.getters.calc.date || !this.$store.getters.calc.date2) {
        Swal.fire({
          icon: "error",
          title: "Ошибка заполнения полей",
          text: "Даты должны обязательно быть заполнены",
        });
        return;
      }

      if (
        !this.$store.getters.calc.days ||
        this.$store.getters.calc.days === -1
      ) {
        Swal.fire({
          icon: "error",
          title: "Ошибка заполнения полей",
          text: "Количество дней должно обязательно быть заполнено",
        });
        return;
      }

      if (
        !this.$store.getters.calc.purchasesVal ||
        this.$store.getters.calc.purchasesVal == 0
      ) {
        Swal.fire({
          icon: "error",
          title: "Ошибка заполнения полей",
          text: "Не выбран Вид закупки",
        });
        return;
      }

      if (
        !this.$store.getters.calc.quaranteesVal ||
        this.$store.getters.calc.quaranteesVal == 0
      ) {
        Swal.fire({
          icon: "error",
          title: "Ошибка заполнения полей",
          text: "Не выбран Вид гарантии",
        });
        return;
      }

      if (
        this.role() == roleObj.rating ||
        this.role() == roleObj.winners ||
        this.role() == roleObj.ratingWinners
      ) {
        const profile = JSON.parse(localStorage.getItem("profile"));
        if (!profile) {
          Swal.fire({
            icon: "error",
            title: "Демо-доступ к калькулятору закончился.",
            html: `Чтобы пользоваться им на специальных условиях, доступных только для участников закрытого клуба агентов, переходи в телеграмм-бота <br />
                  <a href='https://t.me/bankagent_bot?start=calc' target='_blank' >
                    <button type="button" class="swal2-confirm swal2-styled" aria-label="" style="text-decoration: none; display: inline-block; border-left-color: rgb(48, 133, 214); border-right-color: rgb(48, 133, 214); color: white;">
                      Перейти
                    </button>
                  </a>
                `,
            // showCancelButton: true,
            // cancelButtonText: "Понятно",
            showConfirmButton: false,
          });
          this.$router.push("/logout");
          return;
        }

        // const email = profile.emailContact;
        // const ehash = this.stringToHash(email);
        // const dd = localStorage.getItem(`__${ehash}`);
        // const date = moment();
        // if (dd) {
        //   if (moment(dd).isSame(date, "day")) {
        //     Swal.fire({
        //       icon: "error",
        //       title: "Демо-доступ к калькулятору закончился.",
        //       html: `<strong>Вам доступен 1 бесплатный расчет в сутки.</strong> Чтобы получить безлимит и пользоваться калькулятором на специальных условиях, доступных только для участников закрытого клуба агентов, переходи в телеграмм-бота<br />
        //           <a href='https://t.me/bankagent_bot?start=calc' target='_blank' >
        //             <button type="button" class="swal2-confirm swal2-styled" aria-label="" style="text-decoration: none; display: inline-block; border-left-color: rgb(48, 133, 214); border-right-color: rgb(48, 133, 214); color: white;">
        //               Перейти
        //             </button>
        //           </a>
        //         `,
        //       // showCancelButton: true,
        //       // cancelButtonText: "Понятно",
        //       showConfirmButton: false,
        //     });
        //     return;
        //   }
        //   localStorage.setItem(`__${ehash}`,date)
        // }
        // if(!dd){
        //   localStorage.setItem(`__${ehash}`,date)
        // }
      }
      this.$store.commit("SET_PROCESSING", true);

      // this.loading = true;

      var situation;
      if (this.$store.getters.calc.your_situationsVal) {
        situation = this.$store.getters.calc.your_situationsVal.join(",");
      } else {
        situation = null;
      }

      var gar_polz_zaksLocal;
      if (this.$store.getters.calc.gar_polz_zaksVal) {
        gar_polz_zaksLocal = this.$store.getters.calc.gar_polz_zaksVal;
      } else {
        gar_polz_zaksLocal = null;
      }

      await this.$store.dispatch("SET_CALC_PARAM", {
        param: "note",
        value: this.noteForCalc,
      });

      var data = {
        isAvans: this.$store.getters.calc.isAvans,
        isPaper: this.$store.getters.calc.isPaper,
        isBS: this.$store.getters.calc.isBS,
        isGarFormZak: this.$store.getters.calc.isGarFormZak,
        days: this.$store.getters.calc.days,
        date_from: this.dateToCalendar(this.$store.getters.calc.date),
        date_to: this.dateToCalendar(this.$store.getters.calc.date2),
        summ: Number(this.removeCommas(this.$store.getters.calc.summ)),
        purchasesVal: this.$store.getters.calc.purchasesVal,
        quaranteesVal: this.$store.getters.calc.quaranteesVal,
        gar_polz_zak: gar_polz_zaksLocal,
        your_situation: situation,
        session: await this.session(),
        action: "doCalc",
        trebUvelSumm: this.$store.getters.calc.trebUvelSumm,
        trebUvelSumm2: this.$store.getters.calc.trebUvelSumm2,
        smp: this.$store.getters.calc.smp,
        note: this.$store.getters.calc.note,
        lot: this.$store.getters.calc.lot,
        purchase_number: this.$store.getters.calc.purchase_number,
        customer_inn: this.$store.getters.calc.customer_inn,
        customer: this.$store.getters.calc.customer,
        title: this.$store.getters.calc.dogovor_subject,
        date5: new Date(this.$store.getters.calc.date5),
        client_name: this.$store.getters.calc.client_name,
        client_inn: this.$store.getters.calc.client_inn,
        nmkc: Number(this.removeCommas(this.$store.getters.calc.nmkc)),
      };
      try {
        this.clearFilters(); // отчистка фильтра
        const res = await this.$store.dispatch("DoCalc", data);
        // if (res.error) {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Ошибка заполнения полей",
        //     text: res.error,
        //   });
        //   return
        // }
        await this.$store.dispatch("addProductCS"); // получение данных для филтра
        await this.$store.dispatch(
          "SET_CALC_REGISTER_ID",
          res.data.register._id
        );

        this.$store.dispatch("setFilter", true); // включение отображения фильтра
        this.$router.push({ path: "/calcreport", replace: true });
      } finally {
        this.loading = false;
      }
    },
  },
  // watch: {
  //   purchase_number(){
  //     this.FindProtocol()
  //   }
  // }
};
</script>

<style lang="scss">
.fadeAnimation {
  transition: all 0.5s linear;
}

.calcsumm input {
  text-align: center;
  font-size: 25px;
}

.borderedStyle {
  border: 1px;
  border-style: solid;
  border-color: #e4e4e4 !important;
  border-radius: 8px;
}

.centerBlock {
  float: none;
  margin: auto;
}

.m10 {
  margin: 10px;
}

.flex {
  display: flex;
  column-gap: 10px;
}

.summBG {
  font-size: 25px;
}

.theme--light.filledColor.v-input:not(.v-input--is-disabled) input {
  color: #217899;
}

.theme--light.v-messages {
  height: 0;
}

.v-text-field__details {
  display: none;
}

.theme--light.subheader {
  font-size: 15px;
  font-weight: 500;
}

#dateFrom,
#dateTo,
#getDays {
  text-align: center;
  color: #217899;
  margin: 0;
  padding-bottom: 1px;
}

.activeSwitch {
  color: #217899;
}

.v-select__selection--comma {
  color: #217899;
}

#plusfive {
  display: inline-block;
  float: none;
  margin: auto;
  text-align: center;
  color: #217899;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.plusfive_wrapper {
  position: relative;
  text-align: center;
}

#calculatorBlock {
  .v-messages {
    min-height: 0 !important;
    height: 0;
  }

  .v-text-field__details {
    height: 0;
    min-height: 0;
  }

  .theme--light.v-messages {
    height: 0;
    min-height: 0;
  }

  &>.v-text-field__details {
    min-height: 0;
  }

  .centerBlock {
    .v-input__control {
      float: none;
      text-align: center;
      display: block;
      margin: auto;
    }
  }

  .subh {
    font-size: 18px;
    height: 20px;
  }

  .buttonblue {
    background: #217899;
  }

  .textInBottom {
    .v-text-field__details {
      display: inline;
      height: auto;
      min-height: auto;

      .theme--light.v-messages {
        height: auto;

        .v-messages__message {
          margin-top: 2px;
          color: red;
        }
      }
    }
  }
}

#app .v-application .accent--text {
  color: #217899 !important;

  .textInBottom {
    .v-text-field__details {
      display: inline;

      .theme--light.v-messages {
        height: auto;

        .v-messages__message {
          color: red;
        }
      }
    }
  }
}

/* .v-input__prepend-outer .v-icon {
  font-family: "Roboto";
  font-size: 16px !important;
}
.v-input__icon .v-icon {
  font-family: "Roboto";
  font-size: 16px !important;
} */
:root {
  --v-accent-base: #217899 !important;
  --v-primary-base: #217899 !important;
}

.custom-font .v-input__prepend-outer i {
  font-family: "Roboto";
  font-size: 16px;
}

.custom-font .v-input__icon--append-outer i {
  font-family: "Roboto";
  font-size: 16px;
}

#app {
  .custom-mb-10 {
    margin-bottom: 10px;
  }
}
</style>
